(function () {
	"use strict";

	var selectors = {
		groupLabel: ".rcl__group-label",
		optionName: ".rcl__group-label-option-name",
		selectedValue: ".rcl__group-label-selected-value",
		group: ".rcl__group, [data-rcl-group]",
		rubikHost: "rubik-combined-listings",
		optionCandidate: "a, button, input, option, label, [href], [role='button'], [role='radio'], [role='option'], [aria-label], [title], [data-value], [data-option-value], [data-rcl-option], [data-product-handle], [data-product-url]",
		valueNode: "[data-value], [data-option-value], [data-product-title], [data-title], [class*='title'], [class*='name'], [class*='value'], [class*='label']",
		selected: [
			"input:checked",
			"option:checked",
			"[checked]",
			"[selected]",
			"[aria-checked='true']",
			"[aria-selected='true']",
			"[aria-current='true']",
			"[aria-current='page']",
			"[data-selected]",
			"[data-selected='true']",
			"[data-active]",
			"[data-active='true']",
			"[data-current]",
			"[data-current='true']",
			"[data-state='active']",
			"[data-state='selected']",
			"[class*='selected']",
			"[class*='active']",
			"[class*='current']",
			".is-selected",
			".selected",
			".active"
		].join(",")
	};

	var observedRoots = [];

	var rubikSpacingStyle = [
		":host, :where([data-rcl-group]) { --rcl-group-margin-bottom: 32px; }",
		"@media (max-width: 767.98px) { :host, :where([data-rcl-group]) { --rcl-group-margin-bottom: 12px; } }"
	].join("");

	function cleanText(value) {
		return String(value || "").replace(/\s+/g, " ").trim();
	}

	function isIgnoredCandidate(candidate, label) {
		return !candidate ||
			candidate === label ||
			!candidate.matches(selectors.optionCandidate) ||
			candidate.matches(selectors.groupLabel) ||
			candidate.matches(selectors.optionName) ||
			candidate.matches(selectors.selectedValue);
	}

	function labelForInput(input, group) {
		if (!input || !group) {
			return null;
		}

		if (input.id) {
			try {
				var label = group.querySelector("label[for='" + input.id.replace(/'/g, "\\'") + "']");

				if (label) {
					return label;
				}
			} catch (error) {
				return null;
			}
		}

		return input.closest("label");
	}

	function optionContainerForCandidate(candidate, group, label) {
		if (!candidate) {
			return null;
		}

		if (candidate.tagName === "INPUT") {
			var inputLabel = labelForInput(candidate, group);

			if (inputLabel) {
				return inputLabel;
			}
		}

		var optionContainer = candidate.closest(selectors.optionCandidate);

		if (optionContainer && !isIgnoredCandidate(optionContainer, label)) {
			return optionContainer;
		}

		return candidate;
	}

	function selectedTextCandidate(candidate) {
		var ignoredText = [
			"selected",
			"select",
			"seleccionado",
			"seleccionar",
			"current",
			"active"
		];
		var text = cleanText(candidate.textContent);
		var lowerText = text.toLowerCase();

		if (!text || ignoredText.indexOf(lowerText) !== -1) {
			return "";
		}

		return text;
	}

	function valueFromDescendant(candidate) {
		if (!candidate.querySelectorAll) {
			return "";
		}

		var descendants = Array.prototype.slice.call(candidate.querySelectorAll(selectors.valueNode));

		for (var index = 0; index < descendants.length; index += 1) {
			var value = valueFromCandidate(descendants[index]);

			if (value) {
				return value;
			}
		}

		return "";
	}

	function valueFromCandidate(candidate) {
		var attrs = [
			"data-value",
			"data-option-value",
			"data-rcl-option",
			"data-product-title",
			"data-title",
			"aria-label",
			"title",
			"alt",
			"value"
		];

		for (var index = 0; index < attrs.length; index += 1) {
			var value = cleanText(candidate.getAttribute(attrs[index]));

			if (value) {
				return value;
			}
		}

		var descendantValue = valueFromDescendant(candidate);

		if (descendantValue) {
			return descendantValue;
		}

		var image = candidate.querySelector && candidate.querySelector("img[alt]");

		if (image) {
			var imageAlt = cleanText(image.getAttribute("alt"));

			if (imageAlt) {
				return imageAlt;
			}
		}

		return selectedTextCandidate(candidate);
	}

	function normalizedPath(url) {
		try {
			var parsedUrl = new URL(url, window.location.origin);

			return parsedUrl.pathname.replace(/\/$/, "");
		} catch (error) {
			return "";
		}
	}

	function findCurrentUrlValue(group, label) {
		if (!group || !group.querySelectorAll) {
			return "";
		}

		var currentPath = normalizedPath(window.location.href);
		var links = Array.prototype.slice.call(group.querySelectorAll("a[href], [href], [data-product-url]"));

		for (var index = 0; index < links.length; index += 1) {
			var link = links[index];
			var href = link.getAttribute("href") || link.getAttribute("data-product-url");

			if (!href || normalizedPath(href) !== currentPath) {
				continue;
			}

			var candidate = optionContainerForCandidate(link, group, label);

			if (isIgnoredCandidate(candidate, label)) {
				continue;
			}

			var value = valueFromCandidate(candidate);

			if (value) {
				return value;
			}
		}

		return "";
	}

	function findSelectedValue(group, label) {
		if (!group) {
			return "";
		}

		var candidates = Array.prototype.slice.call(group.querySelectorAll(selectors.selected));

		for (var index = 0; index < candidates.length; index += 1) {
			var candidate = optionContainerForCandidate(candidates[index], group, label);

			if (isIgnoredCandidate(candidate, label)) {
				continue;
			}

			var value = valueFromCandidate(candidate);

			if (value) {
				return value;
			}
		}

		return findCurrentUrlValue(group, label);
	}

	function upsertSelectedValue(label, value) {
		var optionName = label.querySelector(selectors.optionName);

		if (!optionName) {
			return;
		}

		var currentValue = label.querySelector(selectors.selectedValue);

		if (!value) {
			if (currentValue && currentValue.textContent) {
				currentValue.textContent = "";
			}

			return;
		}

		if (!currentValue) {
			var doc = label.ownerDocument || (typeof document !== "undefined" ? document : null);

			if (!doc) {
				return;
			}

			currentValue = doc.createElement("span");
			currentValue.className = "rcl__group-label-selected-value";
			label.appendChild(currentValue);
		}

		var displayValue = ": " + value;

		if (currentValue.textContent !== displayValue) {
			currentValue.textContent = displayValue;
		}
	}

	function enhanceRubikSelectedLabelValues(root) {
		var scope = root || document;
		var labels = Array.prototype.slice.call(scope.querySelectorAll(selectors.groupLabel));

		labels.forEach(function (label) {
			var group = label.closest(selectors.group) || label.parentElement;
			var value = findSelectedValue(group, label);

			upsertSelectedValue(label, value);
		});
	}

	function injectRubikGroupSpacing(host) {
		if (!host || !host.shadowRoot || !host.shadowRoot.querySelector) {
			return false;
		}

		if (host.shadowRoot.querySelector("style[data-theme-rcl-group-spacing]")) {
			return true;
		}

		var style = document.createElement("style");

		style.setAttribute("data-theme-rcl-group-spacing", "true");
		style.textContent = rubikSpacingStyle;
		host.shadowRoot.appendChild(style);

		return true;
	}

	function observeRoot(root) {
		if (!root || observedRoots.indexOf(root) !== -1 || !("MutationObserver" in window)) {
			return;
		}

		observedRoots.push(root);

		var observer = new MutationObserver(function (mutations) {
			mutations.forEach(function (mutation) {
				Array.prototype.slice.call(mutation.addedNodes || []).forEach(function (node) {
					if (node.nodeType === 1) {
						enhanceRubikRoots(node);
					}
				});
			});
			enhanceRubikRoots(root);
		});

		observer.observe(root, {
			childList: true,
			subtree: true,
			attributes: true,
			attributeFilter: ["class", "checked", "selected", "aria-checked", "aria-selected", "aria-current", "data-selected", "data-active", "data-current", "data-state"]
		});
	}

	function withRubikShadowRoot(host, callback, attempt) {
		if (!host) {
			return;
		}

		if (host.shadowRoot) {
			observeRoot(host.shadowRoot);
			callback(host.shadowRoot, host);
			return;
		}

		attempt = attempt || 0;

		if (attempt >= 10) {
			return;
		}

		window.setTimeout(function () {
			withRubikShadowRoot(host, callback, attempt + 1);
		}, 100);
	}

	function forEachRubikHost(root, callback) {
		var scope = root || document;
		var hosts = [];

		if (scope.matches && scope.matches(selectors.rubikHost)) {
			hosts.push(scope);
		}

		if (scope.querySelectorAll) {
			hosts = hosts.concat(Array.prototype.slice.call(scope.querySelectorAll(selectors.rubikHost)));
		}

		hosts.forEach(function (host) {
			withRubikShadowRoot(host, callback);
		});
	}

	function forEachOpenShadowRoot(root, callback) {
		var scope = root || document;
		var elements = [];

		if (scope.nodeType === 1) {
			elements.push(scope);
		}

		if (scope.querySelectorAll) {
			elements = elements.concat(Array.prototype.slice.call(scope.querySelectorAll("*")));
		}

		elements.forEach(function (element) {
			if (!element.shadowRoot) {
				return;
			}

			observeRoot(element.shadowRoot);

			if (!element.shadowRoot.querySelector(selectors.groupLabel)) {
				return;
			}

			callback(element.shadowRoot, element);
		});
	}

	function enhanceRubikRoots(root) {
		enhanceRubikSelectedLabelValues(root || document);
		forEachRubikHost(root || document, function (shadowRoot, host) {
			injectRubikGroupSpacing(host);
			enhanceRubikSelectedLabelValues(shadowRoot);
		});
		forEachOpenShadowRoot(root || document, function (shadowRoot, host) {
			injectRubikGroupSpacing(host);
			enhanceRubikSelectedLabelValues(shadowRoot);
		});
	}

	function init() {
		observeRoot(document.body);
		enhanceRubikRoots(document);

		document.addEventListener("click", function (event) {
			if (!event.target || !event.target.closest(selectors.group)) {
				return;
			}

			window.setTimeout(function () {
				enhanceRubikRoots(document);
			}, 0);
		});

		document.addEventListener("change", function (event) {
			if (!event.target || !event.target.closest(selectors.group)) {
				return;
			}

			window.setTimeout(function () {
				enhanceRubikRoots(document);
			}, 0);
		});

	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
}());
